export default "__VITE_ASSET__BkHQ3$LM__"